import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft } = FiIcons;

const LegalNotice = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/" className="inline-flex items-center text-blue-800 hover:text-blue-900 mb-8 transition-colors">
            <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" /> Volver al inicio
          </Link>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Aviso Legal</h1>
            <div className="space-y-6 text-gray-700">
              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Datos Identificativos</h2>
                <p className="mb-3">
                  En cumplimiento con la LSSI, se reflejan los siguientes datos:
                </p>
                <div className="bg-gray-50 p-4 rounded-md border border-gray-100 text-sm">
                  <p><strong>Titular:</strong> ÁNGEL SEISDEDOS GAVIRA</p>
                  <p><strong>Nombre comercial:</strong> BOEResumido.com</p>
                  <p><strong>NIF:</strong> 45.660.354-H</p>
                  <p><strong>Contacto:</strong> contacto@boeresumido.com</p>
                </div>
              </section>
              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Exención de Responsabilidad</h2>
                <p>
                  BOEResumido.com ofrece resúmenes informativos de carácter privado. No somos un organismo oficial. La información contenida en esta web y en los correos electrónicos enviados no tiene validez legal. La única fuente oficial es el Boletín Oficial del Estado (BOE).
                </p>
              </section>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalNotice;